import { FC } from "react";
import { Link } from "@components/atoms";
import Image from "next/legacy/image";
import { HeadingSize, H2 } from "../atoms/Heading";
import styled, { ThemeContext } from "styled-components";
import { color as themeColor, colour } from "@styles";
import { CheckList } from "../molecules/CheckList";
import { Button, buttonVariant } from "../atoms/Button";
import { GiraffePeeper } from "../atoms/Giraffes";
import { Card } from "../templates/Card";
import GiraffeDesk from "../../public/static/img/rebrand/svgs/GiraffeDesk.svg";

const theme = {
  color: colour.white,
  backgroundColor: themeColor.S3100,
};

const listItems = [
  ["Easy-to-buy", "- talk to our team now."],
  ["Easy-to-run", "- with hassle-free digital administration."],
  ["Full access", "to our app, wellbeing partners and rewards."],
];

export const Callback: FC<
  React.PropsWithChildren<{
    id?: string;
    pt?: string;
    pb?: string;
    background?: string;
    backgroundTop?: string;
    backgroundBottom?: string;
  }>
> = ({ id, background, backgroundTop, backgroundBottom, pt, pb }) => {
  return (
    <section id={id}>
      <Card
        pt={pt}
        pb={pb}
        background={background}
        backgroundTop={backgroundTop}
        backgroundBottom={backgroundBottom}
        cardColor="#956AFF"
        positionedElement={
          <>
            <Yugi>
              <Image src={GiraffeDesk} alt="Yugi ready to give you a call" />
            </Yugi>
            <YugiHead>
              <GiraffePeeper />
            </YugiHead>
          </>
        }
      >
        <H2 size={HeadingSize.H1} color={theme.color}>
          We&rsquo;ll give you a call.
        </H2>
        <CheckList
          pt="2.5rem"
          items={listItems}
          textColor={theme.color}
          iconColor={theme.backgroundColor}
          backgroundColor={theme.color}
        />
        <Link passHref href="/get-a-quote/" legacyBehavior>
          <Button variant={buttonVariant.epic}>Request a callback</Button>
        </Link>
      </Card>
    </section>
  );
};

const breakPoint = "87rem";

const Addendum = styled.div`
  margin-top: 1rem;

  @media only screen and (min-width: ${breakPoint}) {
    margin-right: 18.75rem;
  }
`;

const Yugi = styled.div`
  display: block;
  position: absolute;
  bottom: -0.5rem;
  right: -1.7rem;
  transform-origin: bottom right;
  transform: scale(1.15);

  svg {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  @media only screen and (max-width: ${breakPoint}) {
    display: none;
  }
`;

const YugiHead = styled.div`
  display: none;
  position: absolute;
  top: 0;
  right: 0;

  @media only screen and (min-width: 53rem) and (max-width: ${breakPoint}) {
    display: block;
  }
`;
